import React, { useState } from 'react'
import styled from 'styled-components'
import { Rating as RatingComponent } from '@ui-partents/Rating';
import { Rating } from 'react-simple-star-rating'
import { Icon } from '@components/common'
import EditIcon from '@images/teachV2/edit.svg'
import { Input } from 'reactstrap';
import { ButtonComponent } from "@components/patterns/elements/Button";
import { apiCaller } from "@utils";
import { toast } from 'react-toastify';

const ContentFeedback = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-bottom: 1px solid #D0D5DD;
  .rate-info {
    &__user {
      display: flex;
      flex-direction: column;
      gap: 8px;
      h1 {
        font-size: 14px;
        font-weight: 500;
        color: #323232;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #323232;
      }
    }
    &__percent {
      display: flex;
      flex-direction: column;
      align-items: end;
      justify-content: space-between;
      gap: 8px;
      &--edit {
        cursor: pointer;
      }
    }
  }
  .rate-content {
    font-size: 14px;
    font-weight: 400;
    color: #323232;
  }
  .rate-more {
    text-align: right;
    font-size: 14px;
    font-weight: 500;
    color: #0089C2;
  }
  &:last-child {
    border: none;
  }
`

const FormFeedback = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const fillColorArray = [
  "#f17a45",
  "#f19745",
  "#f1a545",
  "#f1b345",
  "#f1d045"
];

export default function DetailComment(props) {
  const { review, dataAnalyze, getLoadDataDetail } = props
  const Account = JSON.parse(localStorage.getItem("Account"));
  const canEdit = Account?.email === review?.email
  const [showEdit, setShowEdit] = useState(false)
  const [valueReview, setValueReview] = useState(review?.Comments)
  const [rating, setRating] = useState(review?.Stars);

  const handleSaveReview = () => {
    const params = {
      Action: "SubmitQuestionBankItemReview",
      QuestionItemId: dataAnalyze?.QuestionItemId,
      Stars: rating,
      Comments: valueReview
    };
    apiCaller(`/feedback/question/items/`, "POST", params).then((res) => {
      if (res?.status === 200) {
        toast.success("Review saved successfully", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        getLoadDataDetail(dataAnalyze?.QuestionItemId)
        setShowEdit(false)
      } else {
        toast.error("Failed to feedback", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }

  const handleRating = (rate) => {
    setRating(rate);
  }

  return (
    <ContentFeedback>
      {!showEdit ? (
        <>
          <div className="rate-info d-flex align-items-start justify-content-between">
            <div className="rate-info__user">
              <h1>{review?.full_name}</h1>
              {review?.edited_at && <p>{review?.edited_at}</p>}
            </div>
            <div className="rate-info__percent">
              {canEdit && (
                <div className="rate-info__percent--edit" onClick={() => setShowEdit(true)}>
                  <Icon src={EditIcon}/>
                </div>
              )}
              <RatingComponent rating={review?.Stars} />
            </div>
          </div>
          <p className="rate-content">{review?.Comments}</p>
        </>
      ) : (
        <>
          <div className="rate-info d-flex align-items-end justify-content-between">
            <div className="rate-info__user">
              <h1>{review?.full_name}</h1>
              <p>{review?.edited_at}</p>
            </div>
            <div className="rate-info__percent">
              <Rating
                onClick={handleRating}
                size={32}
                transition 
                fillColorArray={fillColorArray}
                initialValue={rating}
              />
            </div>
          </div>
          <FormFeedback>
            <Input
              name="suggestion" 
              type="textarea" 
              placeholder="What could be improved in this question? Any suggestions?" 
              style={{ height: '120px' }}
              value={valueReview}
              onChange={(e) => setValueReview(e.target.value)}
            />
            <div className='d-flex align-items-center justify-content-end'>
              <ButtonComponent 
                color="outline"
                disabled={!valueReview}
                onClick={(e) => {
                  e.preventDefault()
                  setShowEdit(false)
                }}
              >
                Cancel
              </ButtonComponent>
              <ButtonComponent 
                className="ml-3"
                disabled={!valueReview}
                onClick={handleSaveReview}
              >
                Save
              </ButtonComponent>
            </div>
          </FormFeedback>
        </>
      )}
    </ContentFeedback>
  )
}
